<template>
    <div class="layout-search-bar relative">
        <button
            role="button"
            class="absolute left-0 h-full bg-transparent px-4 text-zinc-700"
            aria-label="search"
        >
            <IconSearch></IconSearch>
        </button>
        <button
            v-if="searchQuery"
            role="button"
            class="absolute right-0 h-full bg-transparent px-4 text-zinc-500 hover:text-zinc-900"
            @click="clearSearch()"
        >
            <IconClose></IconClose>
        </button>
        <input
            ref="search"
            class="
                focus-active:outline-0 w-full rounded-md border-0
                bg-white px-14 py-4
                text-sm text-zinc-600
                shadow-sm
                ring-1 ring-inset ring-zinc-300 placeholder:text-sm placeholder:italic placeholder:text-zinc-400
                focus:ring-1 focus:ring-inset focus:ring-zinc-400 focus-visible:outline-0
                md:text-lg placeholder:md:text-lg
            "
            :placeholder="placeholder"
            :value="searchQuery"
            @input="event => makeSearch(event.target.value)"
        />
    </div>
</template>

<script>
export default {
    name: 'LayoutSearchBar',
    props: {
        placeholder: {
            required: false,
            type: String,
            default: 'Search...',
        },
        searchQuery: {
            required: true,
            type: String,
            default: '',
        },
        makeSearch: {
            required: true,
            type: Function,
        },
        shouldFocus: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
    },
    methods: {
        focusSearch () {
            let input = this.$refs['search'];
            this.$nextTick(() => {
                if (input) input.focus();
            });
        },
        clearSearch () {
            this.makeSearch('');
        },
    },
    mounted () {
        if (this.shouldFocus) this.focusSearch();
    },
    watch: {
        shouldFocus (newValue) {
            if (newValue) this.focusSearch();
        }
    }
};
</script>
